import { inject, observer } from "mobx-react";
import * as React from "react";
import { RootStore } from "../../stores/rootStore";
import { Manufacturer as NewManufacturer } from "randmar-api-client";
import { Alert, AlertTitle } from "randmarcomps";
import { AlertTriangle } from "lucide-react";

// The legacy Manufacturer object from MobX.
type LegacyManufacturer = {
  onHold?: number;
};

// Type guard to differentiate between legacy and new manufacturer types.
const isLegacyManufacturer = (m: unknown): m is LegacyManufacturer => {
  return typeof m === "object" && m !== null && "onHold" in m;
};

interface IProps {
  store?: RootStore;
  manufacturer?: NewManufacturer;
}

const AccountWarnings: React.FC<IProps> = ({ store, manufacturer: manufacturerProp }) => {
  // The store is injected for legacy support.
  // The manufacturer prop is for new pages using RTK query.
  const manufacturer: unknown = manufacturerProp ?? store?.manufacturerStore.manufacturer;

  if (!manufacturer) {
    return null;
  }

  const isOnHold = isLegacyManufacturer(manufacturer)
    ? Boolean(manufacturer.onHold)
    : typeof manufacturer === "object" && manufacturer !== null && "OnHold" in manufacturer
      ? Boolean((manufacturer as Record<string, unknown>).OnHold)
      : false;

  if (!isOnHold) {
    return null;
  }

  return (
    <Alert variant="destructive" className="mb-2 text-xl">
      <AlertTriangle className="h-6 w-6" />
      <AlertTitle>Your account is on hold</AlertTitle>
    </Alert>
  );
};

export default inject("store")(observer(AccountWarnings));
